// extracted by mini-css-extract-plugin
export default {"cloudCta":"TJOSazoV4SGUa4MVP9LW","cloudUpload":"W8k5hqFdHD76iNhQr3ZQ","cloudUploadButton":"f08fP_yB8yyhmmN0HQ4G","cloudUploadSprite":"TY9nIUWMGIBTWQtyh8_O"};